const enAuth = {
    signInTab: "Sign in",
    signUpTab: "Create account",
    fullNamePlaceholder: "Full name",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Password",
    confirmPasswordPlaceholder: "Confirm password",
    referralCodePlaceholder: "Referral code (optional)",
    createMyAccount: "Create my account",
    forgotPassword: "Forgot your password?",
    orSeparator: "or",
    continueWithGoogle: "Continue with Google",
    termsNotice: "By creating an account you agree to our terms of service",
    authDialogDefaultReason: "Sign in to pick up your analysis where you left it",
    guardTitle: "Sign in to continue",
    guardDefaultReason: "This screen needs an account. It only takes a moment.",
    guardReasonAnalyze: "Sign in to analyse a match",
    guardReasonHistory: "Sign in to see your analysis history",
    guardReasonAccount: "Sign in to open your account",

    invalidReferralCode: "This referral code does not exist, you can leave the field empty",
    validCode: "Valid code",
    invitedYou: "{{name}} invited you",
    discountOffFirstPlan: "{{percent}}% off your first plan",

    enterEmail: "Enter your email address",
    enterPassword: "Enter your password",
    enterName: "Enter your name",
    passwordsMustMatch: "Both passwords must match",
    resetEmailFirst: "Enter your email address first, the reset link is sent to it",
    resetLinkSent: "Check your inbox, a link to choose a new password is on its way"
}

export default enAuth
